"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLoginComponent = void 0;
const interface_1 = require("./interface");
const react_1 = __importStar(require("react"));
const builder_1 = require("./builder");
const utils_1 = require("./utils");
const constants_1 = require("./constants");
const component_styles_1 = require("./component-styles");
const AuthLoginComponent = ({ loginUrl = constants_1.DEFAULT_LOGIN_URL, screen = interface_1.ScreenType.PHONE_INPUT_SCREEN, clientId, phoneNumber, onSuccess, onError, onEdit, styles, }) => {
    const [finalUrl] = (0, react_1.useState)((0, builder_1.buildLoginUrl)(Object.assign({ loginUrl: (0, utils_1.getAbsoluteLoginUrl)(loginUrl), screen,
        phoneNumber,
        clientId }, (onEdit && { customEdit: true }))));
    (0, react_1.useEffect)(() => {
        const LOGIN_HANDLERS = {
            [interface_1.LOGIN_STATUS.SUCCESS]: onSuccess,
            [interface_1.LOGIN_STATUS.FAILURE]: onError,
            [interface_1.LOGIN_STATUS.PHONE_NUMBER_INCORRECT]: onError,
            [interface_1.IFRAME_MESSAGE.EDIT_CLICKED]: onEdit,
        };
        const handleMessage = ({ data }) => { var _a; return (_a = LOGIN_HANDLERS[data]) === null || _a === void 0 ? void 0 : _a.call(LOGIN_HANDLERS); };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [onSuccess, onError]);
    return (react_1.default.createElement(component_styles_1.Wrapper, { styles: styles },
        react_1.default.createElement(component_styles_1.Iframe, { id: "auth-iframe", src: finalUrl })));
};
exports.AuthLoginComponent = AuthLoginComponent;
//# sourceMappingURL=auth-login-component.js.map